import { heroItem, heroUpdates, channelEntries } from "@/mocks/blackdata";

const toneMap: Record<string, string> = {
  primary: "bg-primary-600 text-background-50",
  accent: "bg-accent-500 text-background-50",
  secondary: "bg-secondary-600 text-background-50",
  foreground: "bg-foreground-800 text-background-50",
};

export default function Hero() {
  return (
    <>
      {/* 分区入口条压顶：封面驱动、入口醒目 */}
      <section className="max-w-[1400px] mx-auto px-3 md:px-6 pt-5 md:pt-7">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {channelEntries.map((c) => (
            <a
              key={c.key}
              href={`#${c.key === "figure" ? "figure" : c.key}`}
              className="group relative overflow-hidden rounded-lg min-h-[118px] md:min-h-[150px] bg-foreground-900 flex items-end"
            >
              <img
                src={c.image}
                alt={c.label}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-background-950/35 to-transparent"></div>
              <div className="relative flex flex-col gap-1 p-3 md:p-4 w-full">
                <div className="flex items-center gap-2">
                  <span className={`flex h-6 w-6 items-center justify-center rounded ${toneMap[c.tone]} shrink-0`}>
                    <i className={`${c.icon} text-[13px] w-3.5 h-3.5 flex items-center justify-center`}></i>
                  </span>
                  <span className="font-heading text-[15px] md:text-lg text-background-50 leading-none truncate">{c.label}</span>
                </div>
                <p className="text-[11px] md:text-xs text-background-200/85 truncate">{c.desc}</p>
                <span className="text-[11px] text-accent-400 font-medium">{c.num} · 进入&gt;</span>
              </div>
            </a>
          ))}
        </div>
      </section>

      {/* 头条专题 + 最新更新 */}
      <section id="top" className="max-w-[1400px] mx-auto px-3 md:px-6 pt-5 md:pt-7">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 md:gap-5">
          {/* 头条大卡 */}
          <a href="#timeline" className="group relative lg:col-span-3 overflow-hidden rounded-lg min-h-[300px] md:min-h-[430px] bg-foreground-900 flex items-end block">
            <img
              src={heroItem.image}
              alt={heroItem.title}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950/95 via-background-950/35 to-transparent"></div>
            <div className="relative flex flex-col gap-3 p-4 md:p-7 w-full">
              <div className="flex flex-wrap items-center gap-2">
                <span className="inline-flex items-center gap-1 rounded bg-primary-600 text-background-50 px-2.5 py-1 text-[12px] whitespace-nowrap">
                  <i className="ri-fire-fill w-3.5 h-3.5 flex items-center justify-center"></i>
                  {heroItem.tag}
                </span>
                <span className="text-[12px] text-background-100/80">{heroItem.time}</span>
                <span className="text-[12px] text-accent-400 ml-auto whitespace-nowrap">{heroItem.heat}</span>
              </div>
              <h1 className="font-heading text-xl md:text-3xl text-background-50 leading-snug md:leading-tight">{heroItem.title}</h1>
              <p className="hidden sm:block text-[13px] md:text-sm text-background-200/90 leading-relaxed line-clamp-3 max-w-3xl">{heroItem.summary}</p>
              <div className="flex flex-wrap items-center gap-3 mt-1">
                <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-background-50 text-primary-800 px-3.5 py-2 text-sm font-medium">
                  进入事件时间线
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </span>
                <span className="inline-flex items-center gap-1.5 text-[13px] text-background-100/85">
                  <i className="ri-download-2-line w-4 h-4 flex items-center justify-center"></i>
                  资料包 · 录屏切片
                </span>
              </div>
            </div>
          </a>

          {/* 最新更新列表 */}
          <div className="lg:col-span-2 bg-background-100 border border-background-200 rounded-lg p-3 md:p-4 flex flex-col">
            <div className="flex items-center justify-between px-1 pb-2.5 border-b border-background-200">
              <h2 className="flex items-center gap-2 font-heading text-lg text-foreground-950">
                <span className="inline-block w-1.5 h-4 bg-primary-600 rounded-sm"></span>
                最新实锤动态
              </h2>
              <span className="text-[11px] text-accent-700 inline-flex items-center gap-1 animate-flicker">
                <i className="ri-record-circle-fill w-3.5 h-3.5 flex items-center justify-center"></i>
                LIVE 跟踪中
              </span>
            </div>
            <ul className="flex-1 divide-y divide-background-200">
              {heroUpdates.map((u, i) => (
                <li key={u.id}>
                  <a href="#streamer" className="group flex gap-3 py-2.5">
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-600 text-background-50 text-[11px] font-semibold">
                      {i + 1}
                    </span>
                    <div className="min-w-0">
                      <p className="text-[13px] md:text-sm text-foreground-800 group-hover:text-primary-700 leading-snug line-clamp-2 font-medium">
                        {u.title}
                      </p>
                      <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5 mt-1">
                        <span className="text-[11px] text-foreground-400">{u.tag}</span>
                        <span className="text-[11px] text-foreground-400">{u.time}</span>
                      </div>
                    </div>
                  </a>
                </li>
              ))}
            </ul>
            <a href="#rank" className="mt-2 inline-flex items-center justify-center gap-1.5 rounded-md border border-primary-300 text-primary-700 hover:bg-primary-50 px-3 py-2 text-sm whitespace-nowrap transition-colors">
              只看今日新增（{heroUpdates.length} 条）<i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </section>
    </>
  );
}